import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-royalties-etiquetador",
  templateUrl: "./royalties-etiquetador.component.html",
})
export class RoyaltiesEtiquetadorComponent implements OnChanges {
  private readonly _DEFAULT_ITEMS_PER_PAGE = 10;
  public itemsPerPage = this._DEFAULT_ITEMS_PER_PAGE;
  public currentPage = 1;
  public totalItems: number;
  public firstItemList = 0;
  public lastItemList = this.itemsPerPage;
  public readonly visiblePages = 3;

  public dropdownInfo: number;

  public royalties;
  public dropdownSection: number;
  public cultivosEtiquetador;
  public _royaltiesEtiquetador;

  public _unidadesMedida;
  public _filterProdApplied;

  public columnId: number;

  @Input() set royaltiesEtiquetador(_royalties){
    if(_royalties) {
      this._royaltiesEtiquetador = _royalties;
      this.totalItems = this._royaltiesEtiquetador.length;
      this.royalties = this._royaltiesEtiquetador.slice(0,this.itemsPerPage);
      this.pageChange(1);
      this.dropdownInfo = -1;
      this.dropdownSection = -1;
    }
  };

  @Input() set unidadesMedida(_unidades){
    if(_unidades) this._unidadesMedida = _unidades;
  };

  @Input() set filterProdApplied(applied){
    this._filterProdApplied = applied;
  }

  @Input() resetArrows: boolean;

  @Output() exportPdfEtiquetador = new EventEmitter<number>();

  constructor(private readonly _translate: TranslateService) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Resetear el icono de las flechas al aplicar filtros (evitar que se muestre una ordenación incorrecta anterior)
    if (changes.resetArrows) {
      if (changes.resetArrows.currentValue) {
        this.columnId = 0;
      }
    }
  }

  public get defaultLanguage() {
    return this._translate.getDefaultLang();
  }

  public openTabs(i) {
    this.cultivosEtiquetador = this.royalties[i].lsDetalle;
    this.dropdownSection = this.dropdownSection === i ? -1 : i;
    // Desplazamiento a la izquierda para tablet (mismo tamaño máx. que en table.scss)
    if (this.dropdownSection !== -1 && window.innerWidth <= 1199) {
      // Retardo en caso de que haya otro detalle abierto
      setTimeout(() => {
        document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
      }, 50);
    }
  }

  public exportPdf(i) {
    this.exportPdfEtiquetador.emit(this.royalties[i].etiquetadorId);
  }

  public showDetails(i: number) {
    this.dropdownInfo = this.dropdownInfo === i ? -1 : i;
    if (this.dropdownInfo !== -1 && window.innerWidth <= 1199) {
      setTimeout(() => {
          document.querySelector('table')?.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'start'});
      }, 50);
    }
  }

  public pageChange(page) {
    this.currentPage = page;
    this.firstItemList = this.itemsPerPage * (page - 1);
    this.lastItemList = this.firstItemList + this.itemsPerPage;
    this.royalties = this._royaltiesEtiquetador.slice(this.firstItemList, this.lastItemList);
    this.dropdownInfo = -1;
    this.dropdownSection = -1;
  }

  public itemsPerPageChange(items) {
    this.currentPage = 1;
    this.itemsPerPage = parseInt(items);
    this.firstItemList = 0;
    this.lastItemList = this.itemsPerPage;
    this.royalties = this._royaltiesEtiquetador.slice(this.firstItemList, this.lastItemList);
  }

  public toOrderBy(colId: number) {
    this.columnId = colId;
    this.royalties = this._royaltiesEtiquetador.slice(this.firstItemList, this.lastItemList);
  }

  public getIcon(colId: number) {
    let iconClass = 'fa fa-sort';
    if (colId === this.columnId) {
      const selectedColumn = document.getElementById(`royaltiesGestEtiqCol${this.columnId}`);
      iconClass = selectedColumn.dataset.order === 'desc' ? 'fa fa-sort-up' : 'fa fa-sort-down';
    }
    return iconClass;
  }

  public trackByEtiquetadorId(index: number, royalty: { etiquetadorId: number }): number {
    return royalty.etiquetadorId;
  }
}
